export const SET_PAGE = "SET_PAGE";

export const setPage = (page) => ({type: SET_PAGE, page});
